import React, { Component, PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import { addPaypalRequest, updatePaypalRequest } from 'common/ducks/payout';
import { SubmissionError } from 'redux-form';
import Form from 'account/components/payout/paypal_form';

/**
 * PayPal account modal.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class PaypalModal extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    const { user, onClose, fetchAccounts, onDone, account } = this.props;

    const request = account? updatePaypalRequest : addPaypalRequest;

    return request(user.id, data)
      .then(() => {
        /* close modal and fetch updated accounts list */
        onClose();
        fetchAccounts(true).then(({ data }) => onDone(data));
      }).catch((res) => {
        if (res.data && res.data.email) {
          throw new SubmissionError({email: res.data.email[0]});
        }
        throw new SubmissionError(
          { _error: `Failed to ${account? 'save' : 'add'} PayPal account. Please try again.` }
        );
      });
  }

  render() {
    const { showing, onClose, account } = this.props;
    const initialValues = account? { email: account.email } : undefined;

    return (
      <ModalDialog
        modalOpen={showing}
        dialogClasses="paypal-account"
        modalHeader={(account? "Edit" : "Add") + " PayPal account"}
        closeAction={onClose}
      >
        <Form onSubmit={this.handleSubmit} onCancel={onClose} initialValues={initialValues}
          account={account} />
      </ModalDialog>
    )
  }
}

/**
 * PropTypes.
 *
 * @property {object} user - logged in user
 * @property {object} account - account being edited. If not provided, it's assumed a new one is
                                being added.
 * @property {bool} showing - whether to show this modal
 * @property {func} onClose - called to close this modal
 * @property {func} fetchAccounts - fetch payout accounts
 * @property {func} onDone - callback called when an account is added/edited
 */
PaypalModal.propTypes = {
  user: PropTypes.object,
  account: PropTypes.object,
  showing: PropTypes.bool,
  onClose: PropTypes.func,
  fetchAccounts: PropTypes.func,
  onDone: PropTypes.func,
};



// WEBPACK FOOTER //
// ./account/components/payout/paypal_modal.jsx